export default {
	PLACEHOLDER: 'Write a reason for adjusting order amounts',
	NAV_HEADER: 'Justify Adjustments'
};